import PropTypes from "prop-types";
import NotificationsPopover from "./NotificationsPopover";
// @mui
import { useTheme } from "@mui/material/styles";
import {
  Stack,
  AppBar,
  Toolbar,
  IconButton,
  Avatar,
  Typography,
  MenuItem,
  Link,
  Box,
} from "@mui/material";
import * as URLS from "../../../urls";
import { useState } from "react";
// utils
import { bgBlur } from "../../../utils/cssStyles";
// hooks
import useOffSetTop from "../../../hooks/useOffSetTop";
import useResponsive from "../../../hooks/useResponsive";
// config
import { HEADER, NAV } from "../../../config";
// components
import Iconify from "../../../components/iconify";
import { useSettingsContext } from "../../../components/settings";
//
import Searchbar from "./Searchbar";
// locales
import { useLocales } from "../../../locales";

import Image from "../../../components/image";
import MenuPopover from "../../../components/menu-popover";
import { IconButtonAnimate } from "../../../components/animate";
import { useAuthContext } from "../../../auth/useAuthContext";

// ----------------------------------------------------------------------

Header.propTypes = {
  onOpenNav: PropTypes.func,
};

export default function Header({ onOpenNav }) {
  const theme = useTheme();

  const { logout } = useAuthContext();

  const { themeLayout } = useSettingsContext();

  const isNavHorizontal = themeLayout === "horizontal";

  const isNavMini = themeLayout === "mini";

  const isDesktop = useResponsive("up", "lg");

  const isOffset = useOffSetTop(HEADER.H_DASHBOARD_DESKTOP) && !isNavHorizontal;

  const { translate, allLangs, currentLang, onChangeLang } = useLocales();

  const [openPopover, setOpenPopover] = useState(null);

  var userInfo = JSON.parse(localStorage.getItem("user"));

  const handleOpenPopover = (event) => {
    setOpenPopover(event.currentTarget);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  const handleChangeLang = (newLang) => {
    onChangeLang(newLang);
    handleClosePopover();
    window.location.href = "";
  };

  const renderContent = (
    <>
      {isDesktop && isNavHorizontal}

      {!isDesktop && (
        <IconButton onClick={onOpenNav} sx={{ mr: 1, color: "text.primary" }}>
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>
      )}

      <Stack
        flexGrow={1}
        direction="row"
        // spacing={{ xs: 0.5, sm: 1.5 }}
        alignItems="center"
        justifyContent={"flex-end"}
      >
        {!isDesktop ? (
          <>
            <Link
              underline="none"
              sx={{
                color: "#535353",
                fontWeight: 600,
                fontSize: "16px",
                cursor: "pointer",
                paddingRight: "16px",
              }}
              onClick={() =>
                handleChangeLang(currentLang.value === "en" ? "ar" : "en")
              }
            >
              {currentLang.label}
            </Link>
            <img src="/assets/icons/navbar/setting_ic.svg" alt="arrow" />
            <Link
              underline="none"
              sx={{
                color: "#FFCC63",
                fontWeight: 600,
                fontSize: "16px",
                cursor: "pointer",
                pl: '20px',
                textDecoration: 'underline',
              }}
              onClick={() => logout()}
            >
              {translate('log_out')}
            </Link>
          </>
        ) : (
          <>
            {/* <Box sx={{ width: "252px" }}>
              {" "}
              <img src="assets/icons/navbar/logo.png" alt="logo" />
        </Box>*/}

            <Stack
              //  sx={{ paddingLeft: `calc(100% - ${NAV.W_DASHBOARD - 1}px)` }}
              flexGrow={1}
              direction="row"
              //  spacing={{ xs: 0.5, sm: 1.5 }}
              alignItems="center"
            // justifyContent={"space-between"}
            >
              <Searchbar />

              <Stack
                flexGrow={1}
                direction="row"
                //  spacing={{ xs: 0.5, sm: 1.5 }}
                alignItems="center"
                justifyContent={"flex-end"}
              >
                <Link
                  underline="none"
                  sx={{
                    color: "#535353",
                    fontWeight: 600,
                    fontSize: "16px",
                    cursor: "pointer",
                    paddingRight: "16px",
                  }}
                  onClick={() =>
                    handleChangeLang(currentLang.value === "en" ? "ar" : "en")
                  }
                >
                  {currentLang.label}
                </Link>
                <NotificationsPopover />
                <Stack mr="16px" />
                <Avatar
                  src={`${URLS.baseImageURL}user/${userInfo?.profilePictureUrl}`}
                />
                <Stack mr="8px" />
                <Typography
                  sx={{
                    color: "#535353",
                    fontWeight: 400,
                    fontSize: "13px",
                    paddingRight: "3px",
                  }}
                >
                  {userInfo?.type === "controls" && translate("manager")}:
                  {userInfo?.username}
                </Typography>

                <Link
                  underline="none"
                  sx={{
                    color: "#FFCC63",
                    fontWeight: 600,
                    fontSize: "16px",
                    cursor: "pointer",
                    pl: '20px',
                    textDecoration: 'underline',
                  }}
                  onClick={() => logout()}
                >
                  {translate('log_out')}
                </Link>
              </Stack>
            </Stack>
          </>
        )}
      </Stack>
    </>
  );

  return (
    <AppBar
      sx={{
        position: "realtive",
        background: "#FFFFFF",
        boxShadow: "0px 4px 4px rgba(202, 199, 199, 0.25)",
        height: HEADER.H_MOBILE,
        zIndex: theme.zIndex.appBar + 1,
        border: "1px solid rgba(255, 197, 41, 0.1)",
        ...bgBlur({
          color: theme.palette.background.default,
        }),
        transition: theme.transitions.create(["height"], {
          duration: theme.transitions.duration.shorter,
        }),
        ...(isDesktop && {
          width: `calc(100% - ${NAV.W_DASHBOARD - 1}px)`,
          height: HEADER.H_DASHBOARD_DESKTOP,
          ...(isOffset && {
            height: HEADER.H_DASHBOARD_DESKTOP_OFFSET,
          }),
          ...(isNavHorizontal && {
            width: 1,
            bgcolor: "background.default",
            height: HEADER.H_DASHBOARD_DESKTOP_OFFSET,
            borderBottom: (theme) => `dashed 1px ${theme.palette.divider}`,
          }),
          ...(isNavMini && {
            width: `calc(100% - ${NAV.W_DASHBOARD_MINI + 1}px)`,
          }),
        }),
      }}
    >
      <Toolbar
        sx={{
          height: 1,
          px: { lg: 5 },
        }}
      >
        {renderContent}
      </Toolbar>
    </AppBar>
  );
}
